import React from 'react'
// Removed react-bootstrap layout
import MyInformation from './MyInformation'
import ResetPassword from './ResetPassword'
import PageLayout from '../../components/ui/page-layout'

const Profile = () => {
	return (
		<PageLayout title='Profile'>
		<div className='grid grid-cols-2 gap-4'>
			<MyInformation />
			<ResetPassword />
		</div>
		</PageLayout>
	)
}

export default Profile
